<template>
  <q-chip :color="color" outline>
    {{ role.name }}
  </q-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Role } from '@/type';

const colors = ['red-10', 'red-3', 'indigo-10', 'green-10', 'orange-7'];

export default defineComponent({
  props: {
    role: {
      type: Object as () => Role,
      required: true,
    },
  },
  computed: {
    color(): string {
      return colors[this.role.position - 1];
    },
  },
});
</script>
